import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-491cf180"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传数据")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量修改")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("生成凭证")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("收起")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("更多")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("修改回单")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("回单")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("粘贴回单")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("文件")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("点击选择")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("付款文件(DBS)")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("点击选择")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")

  
const __default__ = {
  name: 'bankFlow'
}
import { useStore } from 'vuex'
import { ref, Ref, reactive, onMounted, computed, nextTick, onActivated} from 'vue'
import DefDropBox from '@/views/ViewsComponents/financial/defDropBox.vue'
import SyncPayBtn from '@/views/ViewsComponents/financial/SynchronizePay.vue'
import SyncAssetBtn from '@/views/ViewsComponents/financial/SynchronizeAssetReceipt.vue'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getNumber, formatNumber } from '@/utils/index'
import { paymentTypeOption } from '@/views/typeMapping/Financial';
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import { useRoute } from 'vue-router'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  'POST/financial_flows/conditions': fetchList,
  // 获取下拉
  'POST/financial_banks/drop_list': dropOptionApi,
  // 导出流水
  'POST/financial_flows/downLoad': downloadApi,
  // 锁定裕解锁
  'PATCH/financial_flows/status': financialFlowLockApi,
  // 手动同步支付池流水
  'POST/financial_flows/sync_flow': financial_flowsSync_flowApi,
  // 银行流水批量修改
  'PATCH/financial_flows/batch': financial_flowsBatchApi,
  // 银行流水修改
  'PATCH/financial_flows': financial_flowsPatchApi,
  // 银行流水单独添加
  'POST/financial_flows': financial_flowsAddApi,
  // 银行流水行批量删除
  'DELETE/financial_flows/batch': batchDelApi,
  // 银行流水上传
  'POST/financial_flows/upload': uploadApi,
  // 银行回单下载
  'GET/bank_receipt/download': downloadReceiptApi,
  // 预览
  'GET/bank_receipt/preview': previewApi,
  // 
  'POST/voucher/generate': generateApi,
  // 银行流水_修改回单编号
  'PATCH/financial_flows/update_receipt_no': update_receipt_noApi,
  // 银行流水_导入回单编号
  'POST/financial_flows/import_receipt_no': import_receipt_noApi,
  // 银行流水_导入修改收付方账户
  'POST/financial_flows/import_cost_to_account': import_cost_to_accountApi,
  // 获取银行流水模板
  'GET/financial_flows/get_upload_enum': get_upload_enumApi,
  // 银行流水_上传回单
  'POST/financial_flows/upload_receipt': upload_receiptApi,
  // 银行流水_上传回单
  'PATCH/financial_flows/batch_paypal_remarks': batch_paypal_remarksApi,
  // 银行流水_上传外汇凭证
  'POST/financial_flows/upload_business_voucher': upload_business_voucherApi,
  // 银行流水_获取凭证
  'GET/bank_receipt/download_voucher': download_voucherApi,
} = Api
const {currencyOption} = PaymentModuleUtils
const route = useRoute()
const store = useStore()
const searchForm: any = ref()


let fullDropObj: any = {
  "accountNumber": ref([]),
  "accountName": ref([]),
  "bankName": ref([]),
  "company": ref([]),
  "currency": ref([]),
}
const paymentDropList = ref([])
const bankTemplate: any = ref([])
onMounted(async() => {
  getDropBoxHandle().then((rep: any) => {
    for (const key in rep) {
      fullDropObj[key].value = [...rep[key]]
    }
  })

  // 获取款型类型
  paymentTypeOption().then((rep: any) => {
    paymentDropList.value = rep
  })


  if(Object.keys(route.query).length == 0){
    searchParamsHandle()
  }

  get_upload_enumApi().then((rep: any) => {
    bankTemplate.value =  []
    for (let key  in rep) {
      bankTemplate.value.push({name: key, id: rep[key] })
    }
  })
    

})

onActivated(() => {
    if(Object.keys(route.query).length){
        Object.assign(searchForm.value.searchFormObject, {...route.query})
        searchForm.value.getDropBoxHandle(route.query)
        searchForm.value.searchHandle(MI_params)
    } 
})



let {
    MI_height, MI_tableData, fetchData, page, size, MI_total, 
    MI_pageChange, MI_sizeChange, MI_identify, MI_params, MI_modifyForm 
} = new tbMix(fetchList)
size.value = 50

// 搜索参数特殊处理函数
const showSummaryFg = ref(true)
const totalObj: any = reactive({
    costOutTotal: 0,
    costOutStandardMoneyTotal: 0,
    costInTotal: 0,
    costInStandardMoneyTotal: 0, 
})

const reloadSummarize = () => {
    nextTick(() => {
        let cellArr: any = document.getElementsByClassName('el-table__footer')[0].getElementsByClassName('cell')
        for (let index = 0; index < cellArr.length; index++) {
            cellArr[index].innerHTML = cellArr[index].innerText
        }
    })
}

// 页面状态不保存，每次进入判断是否跳转
const searchParamsHandle = (params = {sort: '0', createdAt: {}, collectionAt: {}}) => {
  flowTable.value?.clearSelection()
  let sort = params.sort === '0' ? {'file_id': 'DESC'} : {'collection_at': 'DESC'}
  let _params: any = {
    query: {
      ...params,
      verify: true,
    },
    sort
  }

  delete _params.query.collectionRange
  delete _params.query.createdRange

  showSummaryFg.value = false
  fetchData(_params, {} , 1).then(rep => {
    delete rep.rowCount
    delete rep.data
    Object.assign(totalObj, rep)
    showSummaryFg.value = true;
    // 计算当页面合计
    /* const totalArr = ['costOut', 'costOutStandardMoney', 'costIn', 'costInStandardMoney'].reduce((totalArr: string[], propStr: string) => {
      const arr = MI_tableData.value.map(row => row[propStr])
      return totalArr.concat([getNumber(arr.reduce((a, b) => a + b, 0))])
    }, []) */
  }).then(() => {
    reloadSummarize()
  })
}

// 搜索参数
const searchHandle = async (params: object) => {
    showSummaryFg.value = false
    let obj = await fetchData(params, {}, page.value)
    delete obj.rowCount
    delete obj.data
    Object.assign(totalObj, obj)
    showSummaryFg.value = true

    reloadSummarize()
}

const pageChange = async (page: number) => {
    showSummaryFg.value = false
    await MI_pageChange(page)
    showSummaryFg.value = true
    reloadSummarize()
}
const sizeChange = async (size: number) => {
    showSummaryFg.value = false
    await MI_sizeChange(size)
    showSummaryFg.value = true
    reloadSummarize()
}

// 上传银行流水数据
const upConfig = ref([
  {
    type: "SELECT",
    label: "银行类型",
    value: "",
    upKey: "type",
    options: bankTemplate, 
    rule: [{ required: true, message: '请选择银行类型', trigger: 'change' }],
    props: { clearable: true },
    seleProps: { label: "name", valueName: "id" },
  },
  {
    label: '银行账号',
    value: '',
    upKey: 'accountNumber',
    props: { placeholder: '请输入银行账号' }
  }
])
const upFlowEle = ref()
const isShowUpFlow = ref<boolean>(false)
const upFlowObj = reactive({
  type: '', accountNumber: '', file: [], file2: []
})
const upFlowHandle = () => {
  upFlowEle.value.validate().then((valid: boolean) => {
    if(!valid) return Promise.reject();
    const form = new FormData()
    form.append('type', upFlowObj.type)
    form.append('accountNumber', upFlowObj.accountNumber)
    form.append('file', upFlowObj.file[0]?.raw)
    form.append('file2', upFlowObj.file2[0]?.raw)
    return uploadApi(form)
  }).then(() => {
    isShowUpFlow.value = false
    searchHandle(MI_params)
    ElMessage.success('上传成功')

  })
  
}

// 批量修改
const flowTable = ref()
let seleRows = ref<Array<any>>([]) // 选中行
const batchModification = (val: object[]) => {
    seleRows.value = val
}

const modifyFg = ref<boolean>(false)
const modifyConfig: Ref<FromConfig[]> = ref([
    {
        type: 'SELECT',
        // selectType: 'CASCADER',
        label: '款项类型',
        value: '',
        upKey: 'paymentType',
        options: paymentDropList,
        props: { placeholder: '请选择款项类型'},
        seleProps: { label: 'label', valueName: 'id'},
    },
    {
        label: '摘要',
        value: '',
        upKey: 'summary'
    },
    {
        label: '收付方名称',
        value: '',
        upKey: 'costTo'
    },
    {
        label: '备注',
        value: '',
        upKey: 'remarks',
        props: { type: 'textarea', maxlength: 300},
    },
])
const modifyHandle = () => {
    if(seleRows.value.length === 0) {
        ElMessage.warning('请至少选择一条数据')
        return
    }
    MI_modifyForm({}, modifyConfig, modifyFg, async (params: any) => {
        let ids = seleRows.value.map(_row => _row.id)
        await financial_flowsBatchApi({...params, ids})
        ElMessage.success('修改成功')
        flowTable.value!.clearSelection()
        modifyFg.value = false
        searchHandle(MI_params)
    })
}

// 是否禁止多选
const selectableHandle = (row: any, index: any) => {
  return row.status !== 'Lock'
}

// 批量删除
const deleteHandle = () => {
  if(seleRows.value.length === 0) {
    ElMessage.warning('请至少选择一条数据')
    return
  }
  ElMessageBox.confirm('确认批量删除？', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return batchDelApi({ids: seleRows.value.map(_row => _row.id)})
  }).then(() => {
    ElMessage.success('成功')
    MI_identify.value = false
    flowTable.value!.clearSelection()
    searchHandle(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 行编辑
const editFg = ref(false)
const editConfig: Ref<FromConfig[]> = ref([
    {
        type: 'SELECT',
        label: '账户ID',
        value: '',
        upKey: 'accountNumber',
        options: fullDropObj.accountNumber,
        props: { clearable: true, placeholder: '请选择账户ID' },
        seleProps: { label: 'label', valueName: 'id', },
    },
    {
        type: 'SELECT',
        label: '账户简称',
        value: '',
        upKey: 'accountName',
        options:  fullDropObj.accountName,
        props: { clearable: true, placeholder: '请选择账户简称'},
        seleProps: { label: 'label', valueName: 'id', },
    },
    {
        type: "TIME",
        label: "日期",
        value: '',
        upKey: 'collectionAt',
        props: {
            type: 'date',
            clearable: false,
            'value-format': 'YYYY-MM-DD',
            'disabled-date': function(time: any){
                return time.getTime() > Date.now()
            }
        }
    },
    {
        type: 'SELECT',
        label: '收款币别',
        value: '',
        upKey: 'receiptCurrency',
        options: currencyOption(),
        props: { clearable: true, placeholder: '请选择收款币别收款币别',},
        seleProps: {label: 'label',valueName: 'id',}
    },
    {
        label: '收款金额',
        value: '0',
        upKey: 'receiptAmount',
        props: {
            type: 'number'
        },

    },
    {
        label: '手续费',
        value: '0',
        upKey: 'handlingFee',
        props: {
            type: 'number'
        }
    },
    {
        type: 'SELECT',
        label: '币种',
        value: '',
        upKey: 'currency',
        options:  fullDropObj.currency,
        props: { clearable: true, placeholder: '请选择币种'},
        seleProps: { label: 'label', valueName: 'id', },
    },
    {
        label: '借方',
        value: '0',
        upKey: 'costOut',
        props: {
            type: 'number'
        }
    },
    {
        label: '贷方',
        value: '0',
        upKey: 'costIn',
        props: {
            type: 'number'
        }
    },
    {
        type: 'SELECT',
        label: '公司名称',
        value: '',
        upKey: 'costFrom',
        options:  fullDropObj.company,
        props: { placeholder: '请选择公司名称', clearable: true},
        seleProps: { label: 'label', valueName: 'id', },
    },
    {
        label: '收付方名称',
        value: '',
        upKey: 'costTo'
    },
    {
        label: '收付方名称账号',
        value: '',
        upKey: 'costToAccount'
    },
    {
        label: '团队',
        value: '',
        upKey: 'team'
    },
    {
        label: '银行摘要',
        value: '',
        upKey: 'summary'
    },
    {
        type: 'SELECT',
        // selectType: 'CASCADER',
        label: '款项类型',
        value: '空白',
        upKey: 'paymentType',
        options: paymentDropList,
        props: { placeholder: '请选择款项类型' },
        seleProps: { label: 'label', valueName: 'id'},
    },
    {
        type: 'SELECT',
        label: '客户类型',
        value: '',
        upKey: 'domestic',
        options: [
            {label: '境内', id: true},
            {label: '境外', id: false},
        ],
        props: { placeholder: '请选择客户类型', clearable: true},
        seleProps: { label: 'label', valueName: 'id'},
    },
    {
        label: '备注',
        value: '',
        upKey: 'remarks'
    },
])
const editRow = <T extends object>(row: T) => {
    if(row['flowInvoiceId' as keyof T] !== null){
        ElMessage.warning('流水已核销,不可修改')
        return
    }
    // 获取款项类型
      /* let paymentValue = []
      paymentDropList.value.map(e => {
          if(e.label === row.paymentType){
              paymentValue = [e.label]
          } else {
              e.children && e.children.map((_e: any) => {
                  if(_e.label === row.paymentType){
                      paymentValue = [e.label, _e.label]
                  } 
              })
          }
      }) */
    MI_modifyForm(row, editConfig, editFg, async (params: any) => {
        await financial_flowsPatchApi({
            id: row['id' as keyof T],
            ...params,
            // paymentType: params.paymentType,
            collectionAt: dayjs(params.collectionAt).format('YYYY-MM-DDTHH:mm:ss'),
            costOut: params.costOut ? params.costOut : 0,
            receiptAmount: params.receiptAmount ? params.receiptAmount : 0
        })
        editFg.value = false
        ElMessage.success('修改成功')
        searchHandle(MI_params)
    })
}

// 修改回单
const editRowNoFg = ref<boolean>(false)
const editRowNoConfig = ref([
    {
        label: '回单编号',
        value: '',
        upKey: 'receiptNo'
    },
])
const editRowNo = (row: {receiptNo: string | number, id: string}) => {
    MI_modifyForm(row, editRowNoConfig, editRowNoFg, async (params: any) => {
        await update_receipt_noApi({
            id: row.id,
            ...params,
        }, {contentType: 'formData'})
        editRowNoFg.value = false
        ElMessage.success('修改回单成功')
        searchHandle(MI_params)
    })
}

// 锁定
const lockHandle = async (row: any) => {
    await ElMessageBox.confirm(
        '确定要锁定吗？',
        '警告',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
    await financialFlowLockApi({id: row.id, locked: 1, creatorId: store.state.userId})
    ElMessage.success('锁定成功')
    // fetchData(MI_params)
    searchHandle(MI_params)

}
// 解锁
const unlockHandle = async(row: any) => {
    await ElMessageBox.confirm(
        '确定要锁定吗？',
        '警告',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
    await financialFlowLockApi({id: row.id, locked: 0, creatorId: store.state.userId})
    ElMessage.success('解锁成功')
    // fetchData(MI_params)
    searchHandle(MI_params)


}

// 上传回单
const isShowUpRecord = ref<boolean>(false)
const pasteEle = ref()
const upRecordRow: any = reactive({})
let upRecordBlob: any = null
const showUpRecord = (row: any) => {
  Object.assign(upRecordRow, row)
  upRecordBlob = null
  isShowUpRecord.value = true
  nextTick(() => {
    pasteEle.value.innerHTML = '请点击左下按钮粘贴回单'
  })
}

const pasteRecord =  () => {
  navigator.clipboard.read().then(async (clipboardItems: any) => {
    for (const type of clipboardItems[0].types) {
      if (!type.includes("image")) continue;
      // 存在图片
      const blob = await clipboardItems[0].getType(type)
      upRecordBlob = blob


      const url = URL.createObjectURL(blob);
      const img = document.createElement('img');
      img.src = url;
      img.style.display = 'block';
      img.style.margin = 'auto';
      pasteEle.value.innerHTML = ''
      pasteEle.value.appendChild(img)
      
    }
  })
}
const submitRecord = () => {
  if(!upRecordBlob?.size){
    ElMessage.warning('请粘贴回单')
    return
  }
  const file = new File([upRecordBlob], '', {type: upRecordBlob.type})
  upload_receiptApi({
    file,
    id: upRecordRow.id
  }, {contentType: 'formData'}).then(() => {
    ElMessage.success('成功')
    isShowUpRecord.value = false
    searchHandle(MI_params)
  })
}


// 生成凭证
const generateVoucher = async () => {
    if(seleRows.value.length === 0) {
        ElMessage.warning('请至少选择一条数据')
        return
    }
    MI_identify.value = true
    try {
        await generateApi({idList: seleRows.value.map(e => e.id), source: 'FINANCIAL_FLOW'})
        ElMessage.success('生成凭证成功')
        MI_identify.value = false
        flowTable.value.clearSelection()
        searchHandle(MI_params)
    } catch (error) {
        MI_identify.value = false
        
    }
}


// 单独添加（单独上传）
const addFg = ref(false)
const addConfig: Ref<FromConfig[]> = ref([
    {
        type: 'SELECT',
        label: '账户ID',
        value: '',
        upKey: 'accountNumber',
        options: fullDropObj.accountNumber,
        props: { clearable: true, placeholder: '请选择账户ID' },
        seleProps: {
            label: 'label',
            valueName: 'id',
        },
    },
    {
        type: 'SELECT',
        label: '账户简称',
        value: '',
        upKey: 'accountName',
        options:  fullDropObj.accountName,
        props: { clearable: true, placeholder: '请选择账户简称'},
        seleProps: {
            label: 'label',
            valueName: 'id',
        },
    },
    {
        type: "TIME",
        label: "日期",
        value: '',
        upKey: 'collectionAt',
        props: {
            type: 'datetime',
            clearable: false,
            'value-format': 'YYYY-MM-DDTHH:mm:ss',
            'disabled-date': function(time: any){
                return time.getTime() > Date.now()
            }
        }
    },
    {
        type: 'SELECT',
        label: '收款币别',
        value: '',
        upKey: 'receiptCurrency',
        options: currencyOption(),
        props: { clearable: true, placeholder: '请选择收款币别收款币别',},
        seleProps: {
        label: 'label',
        valueName: 'id',
        }
    },
    {
        label: '收款金额',
        value: '0',
        upKey: 'receiptAmount',
        props: {
            type: 'number'
        }
    },
    {
        label: '手续费',
        value: '0',
        upKey: 'handlingFee',
        props: {
            type: 'number'
        }
    },
    {
        type: 'SELECT',
        label: '币种',
        value: '',
        upKey: 'currency',
        options:  fullDropObj.currency,
        props: { clearable: true, placeholder: '请选择币种'},
        seleProps: {
            label: 'label',
            valueName: 'id',
        },
    },
    {
        label: '借方',
        value: '0',
        upKey: 'costOut',
        props: {
            type: 'number'
        }
    },
    {
        label: '贷方',
        value: '0',
        upKey: 'costIn',
        props: {
            type: 'number'
        }
    },
    {
        type: 'SELECT',
        label: '公司名称',
        value: '',
        upKey: 'costFrom',
        options:  fullDropObj.company,
        props: { placeholder: '请选择公司名称', clearable: true},
        seleProps: {
            label: 'label',
            valueName: 'id',
        },
    },
    {
        label: '收付方名称',
        value: '',
        upKey: 'costTo'
    },
    {
        label: '收付方名称账号',
        value: '',
        upKey: 'costToAccount'
    },
    {
        label: '团队',
        value: '',
        upKey: 'team'
    },
    {
        label: '银行摘要',
        value: '',
        upKey: 'summary'
    },
    {
        type: 'SELECT',
        // selectType: 'CASCADER',
        label: '款项类型',
        value: '',
        upKey: 'paymentType',
        options: paymentDropList,
        props: { placeholder: '请选择款项类型'},
        seleProps: { label: 'label', valueName: 'id'},
    },
    {
        type: 'SELECT',
        label: '客户类型',
        value: '',
        upKey: 'domestic',
        options: [
            {label: '境内', id: true},
            {label: '境外', id: false},
        ],
        props: { placeholder: '请选择客户类型', clearable: true},
        seleProps: { label: 'label', valueName: 'id'},
    },
    {
        label: '备注',
        value: '',
        upKey: 'remarks'
    },
])
const addSeparately = (): void => {
    // 获取勾选的第一条
    let addObj = seleRows.value.length >= 1 ? seleRows.value[0] : {}
    MI_modifyForm({...addObj, paymentType: '空白'}, addConfig, addFg, async (params: object) => {
        await financial_flowsAddApi(params)
        addFg.value = false
        ElMessage.success('添加成功')
        // fetchData(MI_params)
        searchHandle(MI_params)
    })
}

// 导出参数
const exportParams = computed(() => {
    

    let paramsObj = searchForm.value
    let tempData = paramsObj?.searchFormObject
    if(!tempData){
        return {}
    }
    let sort = tempData.sort === '0' ? {'file_id': 'DESC'} : {'collection_at': 'DESC'}
    
    return {
        query: {
            ...tempData,
            createdAt: {
                from: tempData.createdRange ? tempData.createdRange[0] : '',
                to: tempData.createdRange ? tempData.createdRange[1] : '',
            },
            collectionAt: {
                from: tempData.collectionRange ? tempData.collectionRange[0] : '',
                to: tempData.collectionRange ? tempData.collectionRange[1] : '',
            },
            ids: seleRows.value.map(_row => _row.id),
        },
        sort,
        page: page.value,
        size: MI_total.value,
    }
})

// 预览
let previewUrl = ref<string>('')
let preveiwFg = ref<boolean>(false)
const previewHandle = (row: {id: string}) => {
  MI_identify.value = true
  downloadReceiptApi({id: row.id}, {responseType: 'blob'}).then((stream: any) => {
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: stream.headers['content-type'] || 'application/pdf;charset=UTF-8' })
    )
    previewUrl.value = url
    preveiwFg.value = true
  }).finally(() => {
    MI_identify.value = false
  })
}

// 预览凭证
const vouRow = reactive({})
const previewVouHandle = (row: {id: number}) => {
  Object.assign(vouRow, row)
  MI_identify.value = true
  download_voucherApi({id: row.id}, {responseType: 'blob'}).then((stream: any) => {
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: 'application/pdf' })
    )
    previewUrl.value = url
    preveiwFg.value = true
  }).finally(() => {
    MI_identify.value = false
  })
}

// ------------------------------
const collapseNames = ref('')
const fixedHeight: any = computed(() =>{
  if(collapseNames.value === '1'){
    return window.innerHeight - 550
  }
  return MI_height
})

// 合计 
const flowSummaries = (param: any) => {
    const { columns, data } = param
    const sums: string[] = ['<div class="totoalTop">当前</div><div class="totoalBotton">合计</div>']
    columns.forEach((column: any, index: number) => {
        if (index === 0) return;
        if(!['costOut', 'costOutStandardMoney', 'costIn', 'costInStandardMoney', 
          'receiptAmount', 'handlingFee'
        ].includes(column.property)){
          sums[index] = '<div class="totoalTop"></div><div class="totoalBotton"></div>'
          return 
        }
        
        const values = data.map((item: any) => Number(item[column.property]))
        sums[index] = '<div class="totoalTop limitLength">' + getNumber(values.reduce((prev: number, curr: number) => {
            const value = Number(curr)
            if (!Number.isNaN(value)) {
            return prev + curr
            } else {
            return prev
            }
        }, 0)) + '</div><div class="totoalBotton limitLength">' + getNumber(totalObj[column.property + 'Total']) + '</div>'

    })
    return sums
}



return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, {
      modelValue: collapseNames.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collapseNames).value = $event)),
      accordion: "",
      class: "mb-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "交易记录",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(DefDropBox, {
              ref_key: "searchForm",
              ref: searchForm,
              onSearchHandle: searchParamsHandle
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_space, { wrap: "" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowUpFlow.value = true)),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_permission, 'Create']
        ]),
        _withDirectives(_createVNode(_component_TheUpBtn, {
          showBtn: true,
          upText: "导入回单",
          upFetch: _unref(import_receipt_noApi),
          upParams: {},
          onUpSuccess: _cache[2] || (_cache[2] = ($event: any) => (searchHandle(_unref(MI_params))))
        }, null, 8, ["upFetch"]), [
          [_directive_permission, 'Create']
        ]),
        _withDirectives(_createVNode(_component_TheUpBtn, {
          showBtn: true,
          upText: "导入修改收付方账户",
          upFetch: _unref(import_cost_to_accountApi),
          upParams: {},
          onUpSuccess: _cache[3] || (_cache[3] = ($event: any) => (searchHandle(_unref(MI_params))))
        }, null, 8, ["upFetch"]), [
          [_directive_permission, 'Create']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addSeparately,
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_permission, 'Create']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "info",
          onClick: modifyHandle,
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_permission, 'Write']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "danger",
          onClick: deleteHandle,
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_permission, 'Delete']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (generateVoucher())),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_permission, 'Write']
        ]),
        _withDirectives(_createVNode(_component_eptBtn, {
          exportFn: _unref(downloadApi),
          exportText: '导出流水',
          exportParam: _unref(exportParams)
        }, null, 8, ["exportFn", "exportParam"]), [
          [_directive_permission, 'Export']
        ]),
        _withDirectives(_createVNode(SyncAssetBtn, {
          onSyncSuccess: _cache[5] || (_cache[5] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
        }, null, 512), [
          [_directive_permission, 'Write']
        ]),
        _withDirectives(_createVNode(SyncPayBtn, {
          onSyncSuccess: _cache[6] || (_cache[6] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
        }, null, 512), [
          [_directive_permission, 'Write']
        ]),
        _withDirectives(_createVNode(_component_TheUpBtn, {
          showBtn: true,
          upText: "CCJK-Paypal备注导入",
          upFetch: _unref(batch_paypal_remarksApi),
          upParams: {},
          onUpSuccess: _cache[7] || (_cache[7] = ($event: any) => (searchHandle(_unref(MI_params))))
        }, null, 8, ["upFetch"]), [
          [_directive_permission, 'Create']
        ]),
        _createVNode(_component_el_button, {
          type: "info",
          icon: "ArrowUp",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (collapseNames.value = ''))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "flowTable",
      ref: flowTable,
      class: "mt-10",
      "show-summary": showSummaryFg.value,
      "summary-method": flowSummaries,
      border: "",
      "default-sort": { prop: 'collectionAt', order: 'descending' },
      "max-height": _unref(fixedHeight) + 'px',
      data: _unref(MI_tableData),
      "row-key": "id",
      onSelectionChange: batchModification
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          type: "selection",
          selectable: selectableHandle,
          width: "55",
          "reserve-selection": true
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "账户ID",
          prop: "accountNumber",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司简称",
          prop: "companyAlias",
          width: "95",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "账户简称",
          prop: "accountName",
          width: "135",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "collectionAt",
          width: "165",
          sortable: ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "借方",
          prop: "costOut",
          width: "135",
          formatter: _unref(formatNumber),
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "借方本位币",
          prop: "costOutStandardMoney",
          width: "135",
          formatter: _unref(formatNumber),
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "贷方",
          prop: "costIn",
          width: "135",
          formatter: _unref(formatNumber),
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "贷方本位币",
          prop: "costInStandardMoney",
          width: "135",
          formatter: _unref(formatNumber),
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "收款币别",
          prop: "receiptCurrency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "收款金额",
          prop: "receiptAmount",
          width: "100",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "手续费",
          prop: "handlingFee",
          width: "100",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "收付方名称",
          prop: "costTo",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "收付方账号",
          prop: "costToAccount",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "银行摘要",
          prop: "summary",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "款项类型",
          prop: "paymentType",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remarks",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "team",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户类型",
          prop: "domestic",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.domestic === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "境内"))
              : _createCommentVNode("", true),
            (row.domestic === false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "境外"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "导入批次",
          prop: "fileId",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "回单",
          prop: "uploadId",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              class: "mr-10",
              onClick: ($event: any) => (previewHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.uploadId)
              ? (_openBlock(), _createBlock(_component_eptBtn, {
                  key: 0,
                  exportFn: _unref(downloadReceiptApi),
                  exportText: '下载',
                  exportParam: {id: row.id}
                }, {
                  default: _withCtx(({exportFn, isLoading}) => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "primary",
                      onClick: exportFn
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_loading, isLoading]
                    ])
                  ]),
                  _: 2
                }, 1032, ["exportFn", "exportParam"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "回单编号",
          prop: "receiptNo",
          "show-overflow-tooltip": "",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "勾销状态",
          prop: "flowInvoiceId",
          formatter: (row) => !row.flowInvoiceId ? '未勾销' : '已勾销',
          width: "90"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "凭证状态",
          prop: "existVoucher",
          formatter: (row) => row.existVoucher === true ? '已生成': '未生成',
          width: "90"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "业务凭证",
          prop: "businessVoucherFileId",
          width: "110"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              class: "mr-10",
              onClick: ($event: any) => (previewVouHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.businessVoucherFileId)
              ? (_openBlock(), _createBlock(_component_eptBtn, {
                  key: 0,
                  exportFn: _unref(download_voucherApi),
                  exportText: '下载',
                  exportParam: {id: row.id}
                }, {
                  default: _withCtx(({exportFn, isLoading}) => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "primary",
                      onClick: exportFn
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_loading, isLoading]
                    ])
                  ]),
                  _: 2
                }, 1032, ["exportFn", "exportParam"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_popover, {
              placement: "left",
              width: 300,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_link, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (editRow(row)),
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (editRowNo(row)),
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write']
                    ]),
                    (row.locked != 1)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          onClick: ($event: any) => (lockHandle(row)),
                          underline: false
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ])
                      : _createCommentVNode("", true),
                    (row.locked == 1)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          key: 1,
                          onClick: ($event: any) => (unlockHandle(row)),
                          underline: false
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ])
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (showUpRecord(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_TheUpBtn, {
                      upText: "外汇凭证",
                      upFetch: _unref(upload_business_voucherApi),
                      upParams: {id: row.id},
                      onUpSuccess: _cache[9] || (_cache[9] = ($event: any) => (searchHandle(_unref(MI_params))))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions, {
                          title: "",
                          column: 4,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, { label: "日期" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss')), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "收付方名称" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.costTo), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "币种" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.currency), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "金额" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getNumber)(row.costOut || row.costIn)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["upFetch", "upParams"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show-summary", "max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      disabled: _unref(MI_identify),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[11] || (_cache[11] = ($event: any) => (_isRef(size) ? (size).value = $event : size = $event)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 200, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: pageChange,
      onSizeChange: sizeChange
    }, null, 8, ["total", "disabled", "currentPage", "page-size"]),
    _createVNode(_component_el_dialog, {
      title: "批量修改",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: modifyConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: addConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: editConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      title: "编辑回单编号",
      modelValue: editRowNoFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editRowNoFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (editRowNoFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: editRowNoConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowUpRecord.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isShowUpRecord).value = $event)),
      title: "上传回单"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (isShowUpRecord.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (submitRecord()))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          title: "",
          column: 4,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(dayjs)(_unref(upRecordRow).collectionAt).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "收付方名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(upRecordRow).costTo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "币种" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(upRecordRow).currency), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(upRecordRow).costOut || _unref(upRecordRow).costIn)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          ref_key: "pasteEle",
          ref: pasteEle,
          class: "paste"
        }, "请点击左下按钮粘贴回单图片", 512),
        _createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (pasteRecord()))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "10px",
      width: "70%",
      modelValue: _unref(preveiwFg),
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(preveiwFg) ? (preveiwFg).value = $event : preveiwFg = $event)),
      title: "预览"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_eptBtn, {
          exportFn: _unref(download_voucherApi),
          type: "primary",
          exportText: '下载',
          exportParam: {id: _unref(vouRow).id}
        }, null, 8, ["exportFn", "exportParam"])
      ]),
      default: _withCtx(() => [
        (_unref(preveiwFg))
          ? (_openBlock(), _createElementBlock("embed", {
              key: 0,
              src: _unref(previewUrl),
              width: "100%",
              height: "500px"
            }, null, 8, _hoisted_22))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowUpFlow.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((isShowUpFlow).value = $event)),
      title: "上传数据",
      onClose: _cache[27] || (_cache[27] = ($event: any) => (upFlowEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[25] || (_cache[25] = ($event: any) => (isShowUpFlow.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: upFlowHandle,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "upFlowEle",
          ref: upFlowEle,
          model: _unref(upFlowObj),
          "label-position": "top",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "银行类型:",
              prop: "type",
              rules: [{ required: true, message: '请选择银行类型', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(upFlowObj).type,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(upFlowObj).type) = $event)),
                  placeholder: "请选择银行类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankTemplate.value, (bank) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: bank.name,
                        value: bank.id,
                        key: bank.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行账号:",
              prop: "accountNumber"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(upFlowObj).accountNumber,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(upFlowObj).accountNumber) = $event)),
                  placeholder: "请输入银行账号",
                  clearable: "",
                  maxlength: "200",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "file",
              rules: [{ required: true, message: '请选择文件', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "",
                  limit: 1,
                  "auto-upload": false,
                  "file-list": _unref(upFlowObj).file,
                  "onUpdate:file-list": _cache[23] || (_cache[23] = ($event: any) => ((_unref(upFlowObj).file) = $event)),
                  "on-change": (file, files) => _unref(upFlowObj).file = files,
                  "on-exceed": () => _unref(ElMessage).warning('超出最大文件数限制')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "on-change", "on-exceed"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "file2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "",
                  limit: 1,
                  "auto-upload": false,
                  "file-list": _unref(upFlowObj).file2,
                  "onUpdate:file-list": _cache[24] || (_cache[24] = ($event: any) => ((_unref(upFlowObj).file2) = $event)),
                  "on-change": (file, files) => _unref(upFlowObj).file2 = files,
                  "on-exceed": () => _unref(ElMessage).warning('超出最大文件数限制')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "on-change", "on-exceed"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})